import React from 'react';
import classNames from 'classnames';
import { SafeText } from '../Typography/components/SafeText/SafeText';
import styles from './KeywordHighlighter.module.scss';
import { useExtractHighlights } from './useExtractHighlights';

export type KeywordHighlighterProps = {
  inclusionWords: readonly string[];
  exclusionWords: readonly string[];
  isHighlightingEnabled: boolean;
  text?: string | null;
};

const KeywordHighlighterBase = ({
  isHighlightingEnabled,
  text,
  inclusionWords = [],
  exclusionWords = [],
}: KeywordHighlighterProps) => {
  const { highlights } = useExtractHighlights({
    text: text || '',
    inclusionWords: inclusionWords,
    exclusionWords: exclusionWords,
    isEnabled: isHighlightingEnabled,
  });

  return (
    <>
      {highlights.map(({ text, type }, index) => {
        if (!type) {
          return <SafeText key={index} text={text} />;
        }

        return (
          <mark key={index} className={classNames(styles.match, styles[type])}>
            {text}
          </mark>
        );
      })}
    </>
  );
};

export const KeywordHighlighter = React.memo(KeywordHighlighterBase);
